module.exports = __webpack_public_path__ + "static/media/Zendy-logo.9cb0abd3.jpg";